<div class="row">
  <div class="col-md-12 mt-36">
    <label for="direccionCompleta">Dirección completa</label>
    <input
      type="text"
      name="direccionCompleta"
      #textoDireccion
      placeholder="Buscar dirección"
    />
    <label class="label-blue"><i class="informativo-blue"></i>&nbsp;Para una mejor experiencia, por favor selecciona la dirección sugerida por Google</label>
  </div>
  
</div>
